module.exports = __webpack_public_path__ + "img/booking-mobile.c8f7da58.png";